import {
	GetRegisteredPlayerRequest,
	GetRegisteredPlayerResponse,
} from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getRegisteredPlayerList } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetRegisteredPlayer(
	payload: GetRegisteredPlayerRequest,
	props?: UseBaseQueryOptions<GetRegisteredPlayerResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetRegisteredPlayerList, payload],
		queryFn: () => getRegisteredPlayerList(payload),
		...props,
	})
}
